import { Button, Grid, IconButton, Typography } from "@mui/material";
import { Box, Container, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import {
    ConfirmTypes,
    SettingsMenuList,
    SideBarMenuNames,
} from "../core/Constants";
import SideBarMenuItems from "./SideBarMenuItems";
import { Link as RouteLink, Navigate, useNavigate } from "react-router-dom";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import UserHelper from "../core/UserHelper";
import { AddNewVendorPage, LoginPage, VendorPage } from "../core/PageConstants";
import RefreshIcon from "@mui/icons-material/Refresh";
import { postAsync } from "../core/serviceClient";
import { connectToStore } from "../data/store";
import Utils from "../core/Utils";
import {
    DataGrid,
    GridActionsCellItem,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import ConfirmPopup from "./common/ConfirmPopup";
import { useDispatch } from "react-redux";
import InventoryMenuItems from "./InventoryMenuItems";

const Vendor = () => {
    const [localSettings, setLocalSettings] = useState({});
    const dispatch = useDispatch();
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [vendorList, setVendorList] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmText, setConfrimText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const columns = [
        {
            field: "vendorStatus",
            headerName: "Active",
            headerClassName: "headerStyle",
            flex: 1,
            type: "boolean",
        },
        {
            field: "vendorName",
            headerName: "Service Details",
            headerClassName: "headerStyle",
            flex: 2,
            renderCell: (params) => {
                const shortDesc = params.row.vendorName;
                const description = params.row.vendorDescription;

                return (
                    <Stack>
                        <Typography
                            padding="0"
                            component="h4"
                            fontSize="2rem"
                            fontWeight="600"
                            className="h4"
                        >
                            {shortDesc}
                        </Typography>
                        <p className="mb-0">{description}</p>
                    </Stack>
                );
            },
        },
        {
            field: "vendorGSTNumber",
            headerName: "GST Number",
            headerClassName: "headerStyle",
            flex: 1,
        },
        {
            field: "remark",
            headerName: "Remark",
            headerClassName: "headerStyle",
            flex: 1,
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            headerClassName: "headerStyle",
            width: 100,
            cellClassName: "actions",
            getActions: ({ row }) => {
                return [
                    UserHelper.CanEdit() ? (
                        <>
                            <GridActionsCellItem
                                icon={<EditRoundedIcon className="icon20" />}
                                label="Edit"
                                className="textPrimary"
                                onClick={() => handleEditInventory(row)}
                                color="inherit"
                            />

                            {/* <GridActionsCellItem
                                icon={<DeleteOutlineIcon className="icon20" />}
                                label="Delete"
                                onClick={() => deleteInventory(row)}
                                color="error"
                            /> */}
                        </>
                    ) : (
                        <GridActionsCellItem
                            icon={<VisibilityIcon className="icon20" />}
                            label="View"
                            // onClick={() => handleEditService(row)}
                            color="inherit"
                        />
                    ),
                ];
            },
        },
    ];

    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(VendorPage, Navigate)) {
            setLocalSettings(localSetting);
        }
    }, []);

    useEffect(() => {
        getInventoryDetails();
    }, [localSettings]);

    const getInventoryDetails = async () => {
        if (localSettings.authenticated) {
            setIsLoading(true);
            let result = await postAsync(
                "Vendor/GetVendorDetails",
                {},
                "",
                "GetAll",
                "GetAllVendorDetailsByBusiness",
                [localSettings.business.id]
            );
            setIsNavigateToLogin(result.isNavigateToLogin);
            if (result.error) {
                setMsgOpen(true);
                setMsgText(result.errorMessage);
            } else {
                if (!Utils.IsNullOrEmptyArray(result.data)) {
                    setVendorList(result.data);
                }
            }
            setIsLoading(false);
        }
    };

    const handleEditInventory = (rows) => {
        navigate(AddNewVendorPage.Path, {
            state: {
                selectedVendor: rows,
            },
        });
    };

    const deleteInventory = (vendor) => {
        setSelectedPackage(vendor);
        setConfrimText(
            "Are you sure you want to delete the " + vendor.vendorName + "?"
        );
        setConfirmOpen(true);
    };

    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        }
    };
    const handleConfirmClose = (value) => {
        setConfirmOpen(false);
        if (value == ConfirmTypes.OK) {
            if (!Utils.IsNullOrEmptyObject(selectedPackage)) {
                UserFormDelete(selectedPackage);
            }
        }
    };

    async function UserFormDelete(Spares) {
        setIsLoading(true);
        let result = await postAsync(
            "Vendor/GetVendorDetails",
            {
                Id: Spares.id,
                product: Spares,
                BusinessId: localSettings.business.id,
            },
            "",
            "Delete",
            "",
            []
        );
        if (result && result.data) {
            await getInventoryDetails();
            setMsgText("Deleted successfully");
            setMsgOpen(true);
        } else {
            setMsgText("Unable to process your request");
            setMsgOpen(true);
        }
        setIsLoading(false);
    }

    const handleRefresh = () => {
        getInventoryDetails();
    };

    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />
                <ConfirmPopup
                    confirmOpen={confirmOpen}
                    confirmText={confirmText}
                    onConfirmClose={handleConfirmClose}
                />
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Inventory} />
                        <Grid xs={12} className="content-sec">
                            <Grid container direction="row" className="">
                                <InventoryMenuItems
                                    selectedMenu={SettingsMenuList.InventorySettings.VendorSetup}
                                />
                                <Grid xs={12} md={9}>
                                    <Grid spacing={2} className="form-sec xs-pd-0">
                                        <Stack
                                            alignSelf="center"
                                            justifyContent="end"
                                            direction="row"
                                            flex="1"
                                        >
                                            <IconButton aria-label="Refresh" onClick={handleRefresh}>
                                                <RefreshIcon sx={{ fontSize: 25 }} />
                                            </IconButton>
                                            {UserHelper.CanAdd() && (
                                                <RouteLink
                                                    to={AddNewVendorPage.Path}
                                                    style={{ "align-self": "center" }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        className="btn btn-sm btn-primary"
                                                    >
                                                        <AddCircleOutlineOutlinedIcon
                                                            fontSize="large"
                                                            sx={{ marginRight: "6px" }}
                                                        />
                                                        <span>Add New</span>
                                                    </Button>
                                                </RouteLink>
                                            )}
                                        </Stack>

                                        <Grid
                                            mt={2}
                                            item
                                            xs={12}
                                            className="font-size-14 data-grid-box"
                                        >
                                            <Box
                                                sx={{
                                                    height: "100%",
                                                    width: "100%",
                                                }}
                                            >
                                                <DataGrid
                                                    getRowId={(row) => row.id}
                                                    rows={vendorList}
                                                    columns={columns}
                                                    disableColumnFilter={true}
                                                    disableColumnMenu={true}
                                                    rowSelection={false}
                                                    sx={{
                                                        boxShadow: 1,
                                                        border: 1,
                                                        borderColor: "primary.light",
                                                        "& .MuiDataGrid-cell:hover": {
                                                            color: "primary.main",
                                                        },
                                                    }}
                                                    slots={{ toolbar: CustomToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                            showFilters: false,
                                                        },
                                                    }}
                                                    className="data-grid"
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarQuickFilter className="searchbar" />
        </GridToolbarContainer>
    );
}

export default Vendor;
